import {
  Component,
  Input,
  ChangeDetectionStrategy,
  ViewEncapsulation,
  ChangeDetectorRef,
  OnChanges,
  SimpleChanges,
  HostListener,
  Output,
  ElementRef,
  ViewChild,
  EventEmitter,
} from '@angular/core';

import mixinDisabled from '../../mixins/disabled';
import { PhxDropdownComponent } from '../dropdown/phx-dropdown.component';
import { POSITION_TYPE } from '../dropdown/overlay-position';
import { ChevronUpDown } from './../icon/icon-map';

export enum PHOENIX_ADDON_ALIGNMENT {
  PREFIX = 'phx-prefix',
  SUFFIX = 'phx-suffix',
}

const baseMixin = mixinDisabled(
  class {
    constructor() {}
  }
);

@Component({
  selector: 'phx-addon',
  templateUrl: './phx-addon.component.html',
  styleUrls: ['./phx-addon.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'phx-addon',
    '[class.phx-disabled]': 'phxDisabled',
    '[class.phx-addon-has-dropdown]': '!!phxDropdownTemplate',
  },
  inputs: ['phxDisabled'],
})
export class PhxAddonComponent extends baseMixin implements OnChanges {
  @Input() public phxSelectedOption: string;
  @Input() public phxDropdownTemplate?: PhxDropdownComponent;
  @Input() public phxDropdownPosition?: POSITION_TYPE = 'bottomLeft';
  @Input() public phxAlignment?: PHOENIX_ADDON_ALIGNMENT = PHOENIX_ADDON_ALIGNMENT.PREFIX;
  @Input() public phxOpen = false;
  @Output() public phxOpenChanged: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('addonTrigger') addonTrigger: ElementRef<HTMLElement>;

  public ChevronUpDownIcon = ChevronUpDown;

  constructor(private cdr: ChangeDetectorRef) {
    super();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    const { phxDisabled, phxSelectedOption, phxOpen } = changes;
    if (phxDisabled || phxSelectedOption) {
      this.cdr.markForCheck();
    }

    if (!phxOpen?.currentValue && phxOpen?.previousValue)
      this.addonTrigger?.nativeElement.focus();
  }

  @HostListener('keydown.space')
  @HostListener('keydown.enter')
  public handleClick():  void {
    this.onDropdownToggle(!this.phxOpen);
    if (!this.phxOpen) {
      this.addonTrigger?.nativeElement.focus();
    }
  }

  @HostListener('keydown.esc')
  public closeDropDown(): void {
    this.onDropdownToggle(false);
  }

  public onVisibleChanged(state): void {
    this.onDropdownToggle(state);
    if (!this.phxOpen) {
      this.addonTrigger?.nativeElement.focus();
    }
  }

  private onDropdownToggle(state: boolean): void {
    this.phxOpen = state;
    this.phxOpenChanged.emit(state);
  }
}
